"use strict";

var _taggedTemplateLiteral = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\nprecision highp float;\nvarying vec2 uv;\nuniform sampler2D t;\nvoid main(){\n  gl_FragColor=texture2D(t,uv);\n}"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GLSL = _interopRequireDefault(require("./GLSL"));

var _Shaders = _interopRequireDefault(require("./Shaders"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = _Shaders.default.create({
  copy: {
    frag: _GLSL.default(_templateObject())
  }
}).copy;

exports.default = _default;